//utils
import sessionManager from '@/utils/managers/sessionManager.js';

//constants
import sessionKeys from '@/utils/sessionKeys.js';

const _state = {
  user: sessionManager.get(sessionKeys.KEY_USER_PROFILE, null),
};

export const initialState = () => _state;

export const state = initialState();
